import axios from "axios";

import { store } from "../store/index.js";

let axiosConfig = {
  headers: {
    AppKey: process.env.REACT_APP_KEY,
    "Content-Type": "application/json",
  },
  baseURL: process.env.REACT_APP_BASE_API_URL,
};

export const requestConfig = axios.create(axiosConfig);

requestConfig.interceptors.request.use(
  async response => {
    const token = store.getState().tokenInfo.access;

    if (token) {
      response.headers["Authorization"] = `JWT ${token}`;
    }

    return response;
  },
  error => Promise.reject(error)
);
